"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const PublisherAfterFindForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAfterFindForm"));
const publisher_form_type_1 = require("@App/enum/publisher-form-type");
const PublisherAddForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAddForm"));
const PublisherCreateForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherCreateForm"));
const contexts_1 = require("@App/contexts");
const AddAdministratorPublisher = () => {
    const { publisherSearchStore, publisherStepStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const itemWasAdded = (publisherName) => publisherStepStore.apItemWasAdded(publisherName);
    const setFinedPublisherToDraft = (publisher) => __awaiter(void 0, void 0, void 0, function* () {
        publisherStepStore.setFoundAdministratorPublisher(publisher);
    });
    const addPublisherToDraft = () => {
        publisherStepStore.addAdministratorPublisherToDraft();
    };
    const setAdministratorPublisherData = (administratorPublisherData) => {
        publisherStepStore.setAdministratorPublisherData(administratorPublisherData);
    };
    (0, react_1.useEffect)(() => () => {
        publisherSearchStore.clearStore();
        publisherStepStore.resetStore();
    }, []);
    switch (publisherStepStore.formType) {
        case publisher_form_type_1.PublisherFormType.add:
            return (react_1.default.createElement(PublisherAddForm_1.default, { itemWasAdded: itemWasAdded, setFoundPublisherToDraft: setFinedPublisherToDraft, topClass: "administrator-publisher-sub-form-component", title: "Add Administrator", subtitle: "First, search by administrator\u2019s name to see if the administrator already exists in your catalog.", searchFilterPlaceholder: "Search administrator\u2019s name", suggestedTitle: "Pick from suggested administrators:", buttonText: "Create Administrator", isAdministrator: true }));
        case publisher_form_type_1.PublisherFormType.create:
            return (react_1.default.createElement(PublisherCreateForm_1.default, { publisherData: publisherStepStore.administratorPublisherData, setPublisherData: setAdministratorPublisherData, addPublisherToDraft: addPublisherToDraft, topClass: "administrator-publisher-sub-form-component", isAdministrator: true }));
        case publisher_form_type_1.PublisherFormType.afterFind:
            return (react_1.default.createElement(PublisherAfterFindForm_1.default, { itemWasAdded: itemWasAdded, setFinedPublisherToDraft: setFinedPublisherToDraft, addPublisherToDraft: addPublisherToDraft, topLevelClass: "administrator-publisher-sub-form-component" }));
    }
};
exports.default = (0, mobx_react_1.observer)(AddAdministratorPublisher);
